import { FolkLLM } from '../folk-llm';
FolkLLM.define();
export { FolkLLM };
//# sourceMappingURL=folk-llm.js.map